import { Avatar, Group, Menu, Text, useMantineTheme } from '@mantine/core';
import { IconBuildingSkyscraper } from '@tabler/icons-react';
import { useProfile } from 'init/use-enforce-profile';
import { doesLocationBelongToPath } from 'modules/Navigation/utils';
import { useHistory, useLocation } from 'react-router';
import { GROUP_OVERVIEW_FEATURE_FLAG, GROUP_ROUTE } from 'shared/constants';
import { useIsFeatureFlagEnabled } from 'shared/utils/feature-flags';
import { MenuItemBadges } from '../MenuItemBadges';

export const GroupMenuItem = () => {
  const history = useHistory();
  const theme = useMantineTheme();
  const { pathname } = useLocation();
  const { group } = useProfile();
  const isGroupOverviewEnabled = useIsFeatureFlagEnabled(GROUP_OVERVIEW_FEATURE_FLAG);

  if (!isGroupOverviewEnabled || !group) return null;

  const isInGroup = doesLocationBelongToPath({ locationPath: pathname, path: GROUP_ROUTE });

  return (
    <Menu.Item
      onClick={() => history.push(GROUP_ROUTE)}
      leftSection={
        <Avatar radius={6} size={24} color="purple">
          <IconBuildingSkyscraper stroke="1.5" size={16} />
        </Avatar>
      }
      styles={isInGroup ? { item: { backgroundColor: theme.colors.purple[1] } } : undefined}
    >
      <Group gap="xs">
        <Text>{group.name}</Text>
        <MenuItemBadges tagLabel="alpha" />
      </Group>
    </Menu.Item>
  );
};
